
import { Item, ItemQuantity, ItemStringQuantity } from "@/types";
import { ItemDatabase } from "@/state/Gacha";
import { defineComponent } from "vue";
import ItemDescriptionOverlay from "./ItemDescriptionOverlay.vue";

export default defineComponent({
  components: { ItemDescriptionOverlay },
  props: {
    obtainedItems: {
      type: Object as () => Array<ItemStringQuantity>,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
  },
  emits: ["exit"],
  data() {
    return {
      activeItemId: "",
      active: true,
    };
  },
  computed: {
    items(): Array<ItemQuantity> {
      return this.obtainedItems
        .map((i) => {
          return { item: ItemDatabase[i.id], quantity: i.quantity };
        })
        .filter((i) => i.quantity > 0);
    },
    activeItem(): Item {
      return ItemDatabase[this.activeItemId];
    },
  },
  methods: {
    exitOutsideCheck(e: Event) {
      if (
        e.target === document.getElementById("item-obtain-overlay-bg") ||
        e.target === document.getElementById("item-obtain-overlay-center-box")
      ) {
        this.active = false;
        (this.$refs.audioExitOverlay as HTMLAudioElement).play();
      }
    },
    exit() {
      if (!this.active) {
        this.$emit("exit");
      }
    },
  },
});
